export default __webpack_public_path__ + "static/media/left-mountains.2c67a818.svg";